import clsx from 'clsx';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface TextFieldProps {
  value: string;
  onChange: (value: string) => void;
  name: string;
  type?: string;
  placeholder?: string;
  label?: string;
  help?: string;
  required?: boolean;
  disabled?: boolean;
  autocomplete?: string;
  className?: string;
  style?: React.CSSProperties;
  icon?: string;
}

const TextField: React.FC<TextFieldProps> = ({
  value,
  onChange,
  name,
  type = 'text',
  placeholder,
  label,
  help,
  required,
  disabled,
  autocomplete,
  className: propsClass,
  style,
  icon,
}) => {
  const className = propsClass ? propsClass : '';
  const { t } = useTranslation();

  return (
    <div className={'form-group m-form__group'}>
      {label && (
        <label htmlFor={name}>
          <Trans>{label}</Trans> {required ? '*' : ''}
        </label>
      )}

      <div className={clsx({ 'm-input-icon m-input-icon--left': !!icon })}>
        <input
          className={'form-control m-input ' + className}
          type={type}
          placeholder={t(placeholder || '')}
          name={name}
          id={name}
          onChange={(e) => onChange(e.target.value)}
          value={value}
          required={!!required}
          disabled={!!disabled}
          autoComplete={autocomplete || 'on'}
          style={style}
        />

        {icon && (
          <span className="m-input-icon__icon m-input-icon__icon--left">
            <span>
              <i className={icon}></i>
            </span>
          </span>
        )}
      </div>
      {help && (
        <span className="m-form__help">
          <Trans>{help}</Trans>
        </span>
      )}
    </div>
  );
};

export default TextField;
